import { useLayer } from '@coursera-web/statsig';

/**
 * Gates the header help dropdown behind the `boost-chatbot-header-everywhere-layer`
 * Statsig experiment (HOME-4951). Returns true when the help dropdown should be shown.
 *
 * `skipExposure` lets a caller short-circuit to `false` for learners the experiment
 * shouldn't count at all (e.g. an org-level override that already decides the outcome),
 * without skipping the `useLayer` hook call itself — `useLayer` only logs a Statsig
 * impression when `.get()` is read, so guarding the read (not the hook) keeps this safe
 * under the Rules of Hooks while still avoiding an exposure for those learners.
 */
const useShouldShowHelpDropdown = (skipExposure = false) => {
  const layer = useLayer('boost-chatbot-header-everywhere-layer');
  if (skipExposure) {
    return false;
  }
  return layer.get('show-boost-chatbot', false);
};

export default useShouldShowHelpDropdown;
